"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var _1ds_core_js_1 = require("@microsoft/1ds-core-js");
var Constants_1 = require("../../../Constants");
var Logging_1 = require("../../../Logging");
var Types_1 = require("../../../Types");
var MICROSOFT_TELEMETRY_GROUP = "4f50731a-89cf-4782-b3e0-dce8c90476ba";
var WWAUploadPlugin = (function (_super) {
    __extends(WWAUploadPlugin, _super);
    function WWAUploadPlugin(componentName) {
        var _this = _super.call(this) || this;
        _this.criticalLoggingChannel = null;
        _this.providerLoggingChannel = null;
        _this.logger = new Logging_1.LogProvider("WWA-Upload");
        var loggerOptions = Windows.Foundation.Diagnostics.LoggingChannelOptions(MICROSOFT_TELEMETRY_GROUP);
        _this.criticalLoggingChannel = Windows.Foundation.Diagnostics.LoggingChannel("Microsoft.Gaming.Critical", loggerOptions);
        _this.providerLoggingChannel = Windows.Foundation.Diagnostics.LoggingChannel("Microsoft.Gaming." + componentName, loggerOptions);
        return _this;
    }
    WWAUploadPlugin.prototype.pause = function () { };
    WWAUploadPlugin.prototype.resume = function () { };
    WWAUploadPlugin.prototype.teardown = function () { };
    WWAUploadPlugin.prototype.flush = function (async, callBack) { };
    WWAUploadPlugin.prototype.processTelemetry = function (env, itemCtx) {
        var loggingFields = Windows.Foundation.Diagnostics.LoggingFields();
        var _meta = env.data._meta;
        var privacyTag = _meta.GtlPrivacyTag || Types_1.PrivacyTag.ProductAndServiceUsage;
        var eventKeyword = _meta.GtlEventKeyword || Types_1.EventKeyword.Measure;
        var eventData = env.data;
        delete eventData._meta;
        if (env.baseType || env.baseData) {
            eventData.baseType = env.baseType;
            eventData.baseData = env.baseData;
        }
        if (eventData instanceof Object) {
            for (var key in eventData) {
                var value = eventData[key];
                this.addLoggingFields(loggingFields, key, value);
            }
        }
        loggingFields.addUInt64("PartA_PrivTags", privacyTag);
        var fullEventName = env.name;
        var isCriticalEvent = fullEventName.startsWith("Microsoft.Gaming.Critical.");
        var eventName = env.name.substring(env.name.lastIndexOf(".") + 1);
        var logLevel = eventName === "Error" ? Types_1.LoggingLevel.Error : Types_1.LoggingLevel.Information;
        var loggingOptions = Windows.Foundation.Diagnostics.LoggingOptions(eventKeyword);
        var selectedLoggingChannel = null;
        if (isCriticalEvent) {
            selectedLoggingChannel = this.criticalLoggingChannel;
        }
        else {
            selectedLoggingChannel = this.providerLoggingChannel;
        }
        selectedLoggingChannel.logEvent(eventName, loggingFields, logLevel, loggingOptions);
    };
    WWAUploadPlugin.prototype.addLoggingFields = function (fields, name, data) {
        if (typeof data === "object" || data instanceof Object) {
            fields.beginStruct(name);
            for (var key in data) {
                var value = data[key];
                this.addLoggingFields(fields, key, value);
            }
            fields.endStruct();
        }
        else if (Array.isArray(data)) {
            if (data.length === 0) {
                fields.addStringArray(name, []);
            }
            else {
                var firstItem = data[0];
                if (typeof data === "object" || firstItem instanceof Object) {
                    var stringifiedArray = [];
                    for (var i = 0; i < data.length; i++) {
                        stringifiedArray.push(JSON.stringify(data[i]));
                    }
                    fields.addStringArray(name, stringifiedArray);
                }
                else if (typeof data === "string" || firstItem instanceof String) {
                    fields.addStringArray(name, data);
                }
                else if (typeof data === "boolean" || firstItem instanceof Boolean) {
                    fields.addBooleanArray(name, data);
                }
                else if (typeof data === "number" || firstItem instanceof Number) {
                    if (Number.isInteger(firstItem)) {
                        fields.addUInt64Array(name, data);
                    }
                    else {
                        fields.addDoubleArray(name, data);
                    }
                }
            }
        }
        else if (typeof data === "string" || data instanceof String) {
            fields.addString(name, data);
        }
        else if (typeof data === "boolean" || data instanceof Boolean) {
            fields.addBoolean(name, data);
        }
        else if (typeof data === "number" || data instanceof Number) {
            if (Number.isInteger(data)) {
                if (data >= Constants_1.INT64_MAX) {
                    fields.addUInt64(name, data);
                }
                else {
                    fields.addInt64(name, data);
                }
            }
            else {
                fields.addDouble(name, data);
            }
        }
    };
    return WWAUploadPlugin;
}(_1ds_core_js_1.BaseTelemetryPlugin));
exports["default"] = WWAUploadPlugin;
//# sourceMappingURL=WWAUploadPlugin.js.map